/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Orders_Estes_Auth_RequiredInputs */

const en_orders_estes_auth_required = /** @type {(inputs: Orders_Estes_Auth_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You must be logged in to book LTL shipments`)
};

const es_orders_estes_auth_required = /** @type {(inputs: Orders_Estes_Auth_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Debes iniciar sesion para reservar envios LTL`)
};

/**
* | output |
* | --- |
* | "You must be logged in to book LTL shipments" |
*
* @param {Orders_Estes_Auth_RequiredInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const orders_estes_auth_required = /** @type {((inputs?: Orders_Estes_Auth_RequiredInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Orders_Estes_Auth_RequiredInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_orders_estes_auth_required(inputs)
	return es_orders_estes_auth_required(inputs)
});